import React, { useCallback, useState } from 'react';
import {
  NonOAuthError,
  TokenResponse,
  useGoogleLogin,
} from '@react-oauth/google';

import googleLogo from '@/assets/google-logo.svg';
import Button from '@/components/Button';
import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import { LoginError } from '../../providers/AuthProvider/helpers';

type GoogleOAuthError = Pick<
  TokenResponse,
  'error' | 'error_description' | 'error_uri'
>;
type GoogleNonOAuthError = NonOAuthError;

interface Props {
  onLoginError?: (
    error: LoginError | GoogleNonOAuthError | GoogleOAuthError,
  ) => void;
}
const GoogleLoginButton: React.FC<Props> = ({ onLoginError }) => {
  const { login, status } = useAuth();

  const [isLoading, setIsLoading] = useState(false);

  const googleLogin = useGoogleLogin({
    onSuccess: credentialResponse => {
      const { access_token } = credentialResponse;
      login({ provider: 'google', payload: { access_token } }).catch(error => {
        setIsLoading(false);

        if (onLoginError) {
          onLoginError(error);
        }
      });
    },

    onError: options => {
      setIsLoading(false);
      if (onLoginError) {
        onLoginError(options);
      }
    },
    onNonOAuthError: nonOAuthError => {
      setIsLoading(false);
      if (onLoginError) {
        onLoginError(nonOAuthError);
      }
    },
  });

  const handleLogin = useCallback(() => {
    setIsLoading(true);

    googleLogin();
  }, [googleLogin]);

  return (
    <Button
      theme="secondary"
      onClick={handleLogin}
      loading={isLoading}
      disabled={status === 'on-hold'}
    >
      <img
        width={32}
        height={16}
        src={googleLogo}
        alt="Faça login com o Google"
      />
      <span style={{ width: '140px', textAlign: 'left' }}>
        Continuar com Google
      </span>
    </Button>
  );
};

export default GoogleLoginButton;
